var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"main",attrs:{"mode":"widthFix","src":_vm.link}}),_c('page-wrap',{attrs:{"title":"核验所需清单"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }